import React from "react";

import styles from "./Label.module.scss";

interface IProps {
  children: React.ReactNode;
}

const Label: React.FC<IProps> = ({ children }) => {
  return <div className={styles.label}>{children}</div>;
};

export default Label;
